export const TriaMark = ({ className = "h-7 w-7" }) => (
  <img src="/brand/tria-symbol.png" alt="" aria-hidden="true" className={className} />
);

export const TriaLogo = ({ dark = false }) => (
  <img
    src={dark ? "/brand/tria-logo-light.webp" : "/brand/tria-logo.webp"}
    alt="TRIA — Educação, Edição, Tecnologia"
    width="640"
    height="226"
    className="h-10 w-auto sm:h-11"
  />
);

export const QuitandaSeal = ({ sig, size = "md", dark = false }) => (
  <span className="inline-flex flex-col items-start leading-none">
    <span className={`f-serif italic font-medium text-[#FF682F] ${size === "lg" ? "text-6xl sm:text-7xl lg:text-8xl" : "text-3xl"}`}>
      Quitanda
    </span>
    <span className={`mt-2 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] ${dark ? "text-[#E9E4DA]" : "text-[#4A525A]"}`}>
      <TriaMark className="h-4 w-4" /> {sig}
    </span>
  </span>
);
